module.exports = __webpack_public_path__ + "public/img/icon_shangchaofuli.274f3dfe.png";